import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import helpers from "../../../Utils/helpers";
import {useDispatch, useSelector} from "react-redux";
import commonActions from "../../../Actions/commonActions";
import {EmailDeliveryLogResults} from "../../../Components/Logging/EmailDeliveryLogResults";
import activityLogActions from "../../../Actions/InternalCustomerAdmin/activityLogActions";
import {EmailDeliveryLogsForm} from "../../../Components/Logging/EmailDeliveryLogsForm";
import Spinner from "../../../Components/Fundamentals/Spinner/Spinner";

export function EmailDeliveryLogContainer({ customer }) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const logs = useSelector(state => state.InternalCustomerAdminReducer.emailDeliveryLogs);
    const form = useSelector(state => state.CommonReducer.forms && state.CommonReducer.forms.emailDeliveryLogForm);
    const isLoading = useSelector(state => state.CommonReducer.dataLoading.emailDeliveryLogs);

    useEffect(() => {
        dispatch(commonActions.startFormEditing('emailDeliveryLogForm', {
            value: customer?.email,
            fromDate: helpers.getCurrentDate(),
            toDate: helpers.getCurrentDate()
        }));

        return () => {
            dispatch(commonActions.cancelFormEditing('emailDeliveryLogForm'));
            dispatch(activityLogActions.clear('emailDeliveryLogs'));
        }
    }, []);
    
    return (<div>
            {form && <EmailDeliveryLogsForm form={form} customer={customer} />}
            {isLoading ? <Spinner/> :
                logs && <EmailDeliveryLogResults logs={logs}/>}
        </div>
    );
}


    